import React from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import BarChart from "./BarChart";
import LineChart from "./lineChart";

const ChannelAnalysis = () => {
  const privateChannelData = {
    categories: ["捷途APP", "捷途小程序"],
    values: [120, 200, 150, 80, 70, 110],
  };

  const publicChannelData = {
    categories: ["抖音", "快手", "视频号", "公众号", "头条号", "小红书"],
    values: [120, 200, 150, 80, 70, 110],
  };

  return (
    <div
      style={{
        padding: "20px",
        width: "100%",
        height: "100%",
        overflow: "scroll",
      }}
    >
      <div style={{ marginBottom: 32 }}>
        统计时间：
        <DatePicker.RangePicker defaultPickerValue={[dayjs(), dayjs()]} />
      </div>
      <div>
        <LineChart style={{ width: "500px", height: "400px" }} />
      </div>
      <div style={{ display: "flex" }}>
        <BarChart
          data={publicChannelData}
          title="公域数据分析"
          style={{ width: "500px", height: "400px" }}
        />
        <div style={{ marginLeft: 32 }}>
          <BarChart
            data={privateChannelData}
            title="私域数据分析"
            style={{ width: "300px", height: "400px" }}
          />
        </div>
      </div>
    </div>
  );
};

export default ChannelAnalysis;
